import { useLocationLogEntryTypes } from "../../hooks/useLocationLogEntryTypes.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntryTypeNames.tsx
var LocationLogEntryTypeNames = ({ entryTypeIds, listAll = true }) => {
	const { data, loading } = useLocationLogEntryTypes({ entryTypeIds }, { cacheStrategy: "cache-only" });
	if (!data?.entryTypes && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.entryTypes || !entryTypeIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "pr-xs shrink truncate",
			children: data.entryTypes[0].name
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.entryTypes.map(({ name }) => name).join(", ") });
};
//#endregion
export { LocationLogEntryTypeNames };

//# sourceMappingURL=LocationLogEntryTypeNames.js.map